import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 sm:flex-initial" }

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { withDefaults, computed, LiHTMLAttributes, useAttrs } from "vue";
import Button from "../Button";

interface LinkProps extends LiHTMLAttributes {
  as?: string | object;
  active?: boolean;
}
// eslint-disable-next-line

const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Link',
  props: {
    as: { default: "a" },
    active: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { as, active } = __props as { as: string | object, active: boolean }



const attrs = useAttrs();

const computedClass = computed(() =>
  twMerge([
    "min-w-0 sm:min-w-[40px] shadow-none font-normal flex items-center justify-center border-transparent text-slate-800 sm:mr-2 dark:text-slate-300 px-1 sm:px-3",
    active && "!box font-medium dark:bg-darkmode-400",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_unref(Button), _mergeProps({
      as: as,
      class: _unref(computedClass)
    }, _unref(_).omit(_unref(attrs), 'class')), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"])
  ]))
}
}

})